// Responsive <picture>: WebP srcset (+ JPEG fallback), explicit width/height
// (protects CLS), lazy by default. Optimized files live in /assets/opt/.
const OPT = "/assets/opt";

export const ResponsiveImage = ({
  base,
  alt,
  width,
  height,
  className = "",
  wrapperClassName = "block h-full w-full",
  sizes = "100vw",
  eager = false,
  testId,
}) => {
  const p = `${OPT}/${base}`;
  return (
    <picture className={wrapperClassName}>
      <source
        type="image/webp"
        srcSet={`${p}-480.webp 480w, ${p}-960.webp 960w, ${p}-1440.webp 1440w`}
        sizes={sizes}
      />
      <img
        src={`${p}-1440.jpg`}
        srcSet={`${p}-480.jpg 480w, ${p}-1440.jpg 1440w`}
        sizes={sizes}
        alt={alt}
        width={width}
        height={height}
        loading={eager ? "eager" : "lazy"}
        decoding="async"
        fetchPriority={eager ? "high" : "auto"}
        className={className}
        data-testid={testId}
      />
    </picture>
  );
};

export const baseFromSrc = (src) => src.split("/").pop().replace(/\.(jpg|jpeg|png|webp)$/i, "");
